module.exports = require("npm:url@0.10.3/url.js");